export { default } from './GuidelineFullView';
